module.exports = __webpack_public_path__ + "static/media/less.acb87955.svg";